
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent13 as ObiWindApparent13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-13.js';
 
 
 

 
 export const ObiWindApparent13 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-13',
   elementClass: ObiWindApparent13Element,
   events: {
     
   }
  });
 
 